<script setup lang="ts"></script>
<template>
  <v-card class="pa-8 ma-8 d-flex flex-column flex-wrap" outlined>
    <h2>How to play</h2>
    <p>
      Hnefatavl is a northern European board game. The game simulates an attack
      on the castle where the king is. The game is played on a 11x11 board. The
      exact rules of the game are not known, but researchers have tried to
      reconstruct the rules based on historical sources.
    </p>
    <br />
    <h3>Player 1: the Attacker</h3>
    <li>
      24 attackers are placed in the fields on every side of the game board.
    </li>
    <h3>Player 2: the Defender</h3>
    <li>1 king is placed in the very center the game board.</li>
    <li>12 defenders are placed around the king.</li>
    <br />
    <h3>Making a move</h3>
    <li>The players take turns making a move. The Attacker begins.</li>
    <li>
      All pieces can move either vertically or horizontally to a free field, but
      can't jump over other pieces on the way, just like the rook in chess.
    </li>
    <li>
      It is illegal for pieces to be standing on the corner and the middle
      field, but it is legal to move over the middle field if the king is not
      standing there. Only the king is allowed on the corner fields.
    </li>
    <br />
    <h3>Conquering a piece</h3>
    <p>
      You can conquer your opponents pieces in different ways. Conquered pieces
      are removed from the game. You conquer a piece when:
    </p>
    <li>
      You put a piece next to one of your opponent, while also having one of
      your pieces on the other side.
    </li>
    <li>
      You put a piece next to one of your opponent, while either a corner field,
      the center field, or the edge of the board is on the other side.
    </li>
    <p>
      A piece is NOT conquered when itself is moved, e.g. when a piece is moved
      between two opposing pieces, it remains on the board.
    </p>
    <p>
      The king can only be captured if it is surrounded by attackers on all four
      sides or when it is surrounded on three sides with the center square on
      the fourth side.
    </p>
    <br />
    <h3>Win conditions</h3>
    <li>The attacker wins if the king is captured.</li>
    <li>
      The defender wins if the king is moved onto one of the corner squares.
    </li>
  </v-card>
</template>

<style scoped></style>
